import { defineAction, number, object } from '~/prix'
import geoNeighborhoodCoverageAfterAction from './geoNeighborhoodCoverageAfter.action.json' with { type: 'json' }

const geoNeighborhoodCoverageAfterDefinition = defineAction({
  ...geoNeighborhoodCoverageAfterAction,
  input: object({
    municipalityId: number(),
  }),
  output: object<any>({}),
})

export default geoNeighborhoodCoverageAfterDefinition
